// src/api/index.js
import axios from "axios";

const API = axios.create({
  baseURL: "https://apiweloveschool20240421134825.azurewebsites.net/",
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default API;
